<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="Routelink(onlyOneChild)">
        <el-menu-item :index="onlyOneChild.name" :class="{'submenu-title-noDropdown':!isNest}">
          <i v-if="onlyOneChild.meta.icon" :class="onlyOneChild.meta.icon" />
          <i v-else class="menu-icon-placeholder" />
          <span slot="title">{{ onlyOneChild.meta.title }}</span>
        </el-menu-item>
      </app-link>
    </template>
    <el-submenu v-else ref="subMenu" :index="item.name" popper-append-to-body>
      <template slot="title">
        <i v-if="item.meta.icon" :class="item.meta.icon" />
        <i v-else class="menu-icon-placeholder" />
        <span slot="title">{{ item.meta.title }}</span>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>
<script type="es6">
import { isExternal } from '../../libs/util';
import AppLink from './Link';
export default {
  name: 'SidebarItem',
  data () {
    this.onlyOneChild = null;
    return {
    };
  },
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AppLink
  },
  computed: {},
  methods: {
    hasOneShowingChild (children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });
      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }
      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, noShowingChildren: true };
        return true;
      }
      return false;
    },
    Routelink (route) {
      if (isExternal(route.path)) {
        return { fullPath: route.path, target: route.target || '_blank' };
      } else {
        return { name: route.name };
      }
    }
  },
  mounted () {

  }
};
</script>
<style lang="scss">
  .menu-icon-placeholder{
    display: inline-block;
    width: 24px;
    margin-right: 5px;
    flex-shrink: 0;
  }
  .el-menu--collapse .el-submenu>.el-submenu__title{
    span {
      height: 0;
      width: 0;
      overflow: hidden;
      visibility: visible;
      display: inline-block;
    }
    .el-submenu__icon-arrow {
      display: none;
    }
  }
</style>
